import { useTranslation } from 'react-i18next';

import { searchFieldKeys, useSearch } from './contexts/SearchContext';
import { SearchModeSwitch } from './SearchModeSwitch';
import { SearchTypeSwitch } from './SearchTypeSwitch';
import { cn } from '~/utils/cnTailwind.ts';

export const SearchFieldOptions = () => {
    const { t } = useTranslation();
    const { handleAddSearchField, searchFields } = useSearch();

    return (
        <div className="text-xs mb-2 text-blue-dark flex flex-col gap-3">
            <div className="flex justify-between items-center">
                <span className="font-bold pl-2">{t('LEADS.SEARCH.POSSIBLE_SEARCHFIELDS')}</span>
                <div className="flex gap-4 items-center">
                    <SearchModeSwitch />
                    <SearchTypeSwitch />
                </div>
            </div>
            <div className="inline-flex flex-wrap gap-1">
                {searchFieldKeys.map((key) => (
                    <span
                        key={key}
                        className={cn(
                            'inline-flex items-center bg-grey-light text-xs rounded-xl px-3 py-1',
                            Object.keys(searchFields).includes(key)
                                ? 'text-gray-500 cursor-default'
                                : 'text-blue-dark cursor-pointer',
                        )}
                        onClick={() =>
                            !Object.keys(searchFields).includes(key) ? handleAddSearchField(key) : undefined
                        }
                    >
                        {key.charAt(0).toUpperCase() + key.slice(1)}
                    </span>
                ))}
            </div>
        </div>
    );
};
